export default {
  data() {
    return {
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      modalPosX: 0,
      modalPosY: 0,
      overlayElement: null,
      modalStyle: {
        transform: 'translate(0px, 0px)',
        position: 'relative',
        zIndex: 1000,
      },
    };
  },
  methods: {
    startDrag(event) {
      this.isDragging = true;
      this.dragStartX = event.clientX - this.modalPosX;
      this.dragStartY = event.clientY - this.modalPosY;

      const modal = this.$refs.modal;
      const modalElement = modal.$el || modal;
      this.overlayElement = modalElement.closest('.v-overlay__content');
      const grandparent = modalElement.closest('.v-overlay');

      if (this.overlayElement) {
        // Find the highest z-index among all v-dialogs
        let highestZIndex = 0;
        document.querySelectorAll('.v-overlay').forEach((modal) => {
          const zIndex = parseInt(window.getComputedStyle(modal).zIndex, 10);
          if (zIndex > highestZIndex) {
            highestZIndex = zIndex;
          }
        });

        // Set the z-index of the selected modal to be higher than the highest z-index found
        grandparent.style.zIndex = highestZIndex + 1;
      }

      window.addEventListener('mousemove', this.onDrag);
      window.addEventListener('mouseup', this.stopDrag);
    },
    stopDrag() {
      this.isDragging = false;
      window.removeEventListener('mousemove', this.onDrag);
      window.removeEventListener('mouseup', this.stopDrag);
    },
    onDrag(event) {
      if (this.isDragging) {
        const modal = this.$refs.modal;
        const modalElement = modal.$el || modal;

        let newPosX = event.clientX - this.dragStartX;
        let newPosY = event.clientY - this.dragStartY;

        const boundingRect = this.overlayElement.getBoundingClientRect();

        // Update the modal position
        this.modalPosX = newPosX;
        this.modalPosY = newPosY;

        if (this.overlayElement) {
          this.overlayElement.style.transform = `translate(${this.modalPosX}px, ${this.modalPosY}px)`;
        } else {
          console.error(
            'Could not find the overlay element. Make sure the draggable modal is inside a v-dialog or v-dialog-overlay.',
          );
        }
      }
    },
  },
};
